import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from '../../config/types';
import {REQUEST_SLICE} from './request-slice-constants';
import {IRequestSliceState} from './request-slice-type';

const selectRequestSliceState = (state: TAppState) => state[REQUEST_SLICE];

export const selectRequestData = createSelector(
    selectRequestSliceState,
    state => state?.requestData,
);
export const selectRequestReplies = createSelector(
    selectRequestSliceState,
    state => state?.requestData?.requestReplies,
);
export const selectRequestStatus = (requestKey: string) => createSelector(
    selectRequestSliceState,
    (state: IRequestSliceState) => state?.requestStatuses?.[requestKey],
);
export const selectRequestFields = createSelector(
    selectRequestSliceState,
    (state: IRequestSliceState) => state?.requestFormFields,
);
export const selectRequestAdditionalFields = createSelector(
    selectRequestSliceState,
    state => state?.requestData?.requests?.flexFieldList,
);
export const selectSubmitButtonActionType = createSelector(
    selectRequestSliceState,
    state => state?.submitButtonActionType,
);
